<template>
  <div class=" is-fullwidth">
    
    <div class="notification is-info" v-if="loading === true">Loading To Do items ...</div>

    <div class="notification is-warning" v-if="this.tasks.length==0 && loading === false">There are no open To Do items. Brilliant</div>
    
    <div v-if="this.tasks.length > 0 && loading === false">
      <div class="select is-pulled-right">
        <select v-model="selected_section_name">
          <option value="">Select Section ...</option>
          <option v-for="row in Object.keys(uniqueSectionNames)" :key="row">{{ row }}</option>
        </select>
      </div>
       

            <div class="box">	
              
              <table class="table is-striped is-fullwidth is-hoverable" >
                <thead>
                  <tr>
                    <th>&nbsp;</th>
                    <th width="20%">Section</th>
                    <th>Task</th>
                    <th width="10%">Due Date</th>
                    
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in this.sortedTasksByPriority" :key="row.id">
                    <td><span class="tag" :class="{'is-danger' : row.priority == 4, 'is-warning' : row.priority == 3, 'is-success' : row.priority == 2}">{{  row.priority - 1 }}</span></td>
                    <td>{{ row.section_name }}</td>
                    <td>{{ row.content }}</td>
                    <td><span v-if="row.due != null">{{ row.due.date }}</span></td>
                    
                  </tr>
                </tbody>
              </table>

            </div>

    </div>

</div>
</template>

<script>


//import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
       orders: [],
      showModal: false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      APP_URL : process.env.VUE_APP_URL,
      search: '',
      working: false,
      accessToken: '',
      tasks: [],
      selected_section_name: ''
      
    }
  },
   methods: {
    
    
      async getTodoist() {
        this.loading = true;
        UtilityService.getSimpleApiData(this.accessToken, "todoist").then(
               response => {
                this.tasks = response 
                this.loading = false;
               }
            );
      },
      
  
    
  },
  computed : {
    sortedTasksByPriority() {
        return this.filteredTasks.slice().sort((a, b) => b.priority - a.priority);
    },
    uniqueSectionNames() {
      const sections = {};

      this.tasks.forEach(task => {
        if (task.section_name && !(task.section_name in sections)) {
          sections[task.section_name] = true;
        }
      });

      return sections;
    },
    filteredTasks() {
      if (this.selected_section_name && this.selected_section_name.trim() !== '') {
        return this.tasks.filter(task => task.section_name === this.selected_section_name);
      } else {
        return this.tasks;
      }
  }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getTodoist();
          
        });
  },
 
  mounted() {
    
      
  },
  watch: {
    '$route'() {
      
    }
  }
}


</script>

